import { Commit } from 'vuex';
import { getCityList } from "../../apis/cityApis";

export type CityItem = {
  cityCode: string
  cityName: string

}
export type CityListItem = {
  prefix: string
  cityList: CityItem[]

}
export type CityState = {
  defaultCity: string
  hosList: CityItem[] // 热门城市
  fullList: CityListItem[] // 城市列表
  letters: string[] // 字母
  cityList: CityItem[]// 总城市列表
  searchList: CityItem[]// 总城市列表
}

const initState: CityState = {
  defaultCity: '',
  hosList: [],
  fullList: [],
  letters: [],
  cityList: [],
  searchList: [],
};

const actions = {
  /**
   * 城市列表数据
   */
  actionCityList: async ({ commit }: { commit: Commit; state: CityState }) => {
    const res = await getCityList();
    // console
    commit('setDatas', {
      key: 'hosList',
      value: res.data.hosList,
    });
    commit('setDatas', {
      key: 'fullList',
      value: res.data.fullList,
    });
    const letters = res.data.fullList.map((item: any) => item.prefix);
    commit('setDatas', {
      key: 'letters',
      value: letters,
    });
    let cities: any = [];
    res.data.fullList.forEach((item: any) => {
      cities = cities.concat(item.cityList);
    });
    commit('setDatas', {
      key: 'cityList',
      value: cities,
    });
  },
  actionSearchCity: async ({ commit }: { commit: Commit; state: CityState }, cityName: string) => {
    const searchList = initState.cityList.filter((array) => array.cityName.match(cityName));
    commit('setDatas', {
      key: 'searchList',
      value: searchList,
    });
  },

  actionCity: async ({ commit }: { commit: Commit; state: CityState }, cityName: string) => {
    commit('setDatas', {
      key: 'defaultCity',
      value: cityName,
    });
  },
};

// mutations
const mutations = {
  setDatas: (state: CityState | any, cellData: { key: string, value: any }) => {
    if (!cellData || !cellData.key) {
      return;
    }

    const { key } = cellData;
    state[key] = cellData.value;
  },
  setOrderState: (state: CityState, newState: CityState) => {
    if (!newState) {
      return;
    }

    Object.keys(newState).forEach((key) => {
      state[key] = newState[key];
    });
  },
};

export default {
  namespaced: true,
  state: initState,
  actions,
  mutations,
};
